module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKBAMAAACQ3rmwAAAAJFBMVEUAAAD/aZb/aY/6aZH9aY/9aZD7aY/8aY/9aY/8aY/8aY/8aY/qqx6KAAAAC3RSTlMAESIzZneImczd7qo/uEAAAAA8SURBVAjXY2BgMGMAAebVBSDKqnU7iLNCwBvItWo0YwFyM4RXF3gpALnFy0FyyxmsQHIFIBZDOlDEUgEAql0MqcbMAzkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/double-arrow.png
// module id = 681
// module chunks = 0